import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_aay95qmjim: FaireBrandEntity = {
  token: "b_aay95qmjim",
  type: "brand",
  name: "Ogre Sauce",
  avatarUrl:
    "https://cdn.faire.com/fastly/92ced1e17d6554d84cd5164e076455294ed1fc22e3ee18834b3d3bb8c02ba188.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/9b60b06184841270340078cba1f1f71f44e1174fdcd664b0b2d48b7797a60fcd.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/92ced1e17d6554d84cd5164e076455294ed1fc22e3ee18834b3d3bb8c02ba188.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/9b60b06184841270340078cba1f1f71f44e1174fdcd664b0b2d48b7797a60fcd.jpeg",
  location: "Charlotte, NC, USA",
  minimumOrderDollars: 20,
  rating: 5,
  reviewCount: 27,
  isTopShop: true,
  isInsider: true,
  description:
    "If the name alone doesn’t get your attention, then the bold flavors of this BBQ sauce certainly will. Ogre Sauce is the perfect blend of Carolina sauce traditions: Eastern NC Vinager, Western NC Tomato, and SC Mustard! \n\nWhile it’s great on pulled pork, ribs, or any other barbecue,  it also shines when you discover that it’s just as good on almost everything else. Pair it with your grilled veggies, burgers, oysters, or use it as a dip and discover why this truly is an incredibly versatile, cooking essential.If the name alone doesn’t get your attention, then the bold flavors of this BBQ sauce certainly will.\n\nMike “Ogre” Weeks found his grandmother’s recipe, made it his own, and before long was selling it in five gallon buckets out of the trunk of his car.  With the recipe perfected after countless backyard cookouts and gatherings, childhood friends Mike and Mike bottled Ogre Sauce with the goal of being the BBQ sauce and condiment of every restaurant, food truck and family kitchen.\n",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:51:19.737Z",
    importedBy: "entity-db-cli",
  },
};
